module.exports = __webpack_public_path__ + "img/Menu-07.8292256c.webp";